// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","wrapper":"_1LpeErH_d9c_rL4O-QKI8w","preloader":"_2wpGroLYWU0ICBtuqswr-J","nav-wrapper":"_2TD9Mxh-FC6_E1MgMj_0EX","links":"aREZ4ICpMcrmdRVH0VRzt","link":"_3QkPLRHzkx9XzFCfRada9b","button":"_42gxOwal4Zod_9bM2_UMD","button-icon":"faTGoFWDS43k1iQLr4eCC","note-viewer-wrapper":"_25SoHCunFFa7PHb4rqhrCS","sticky":"iM_Z30jayE4hSACYBFhMa"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/Journal.mod.css
// module id = 1800
// module chunks = 0